import './index.scss'

import { Core } from './modulos/core/core'
import reportWebVitals from './reportWebVitals'

import { createRoot } from 'react-dom/client'
const container = document.getElementById('root')
const root = createRoot(container) // createRoot(container!) if you use TypeScript
root.render(<Core />)

reportWebVitals()
